// package block
import { useCallback, useEffect, useRef, useMemo, useState } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { Modal, notification, Spin } from "antd";
import { useReactToPrint } from "react-to-print";
import { Button, Row, Col, Container, Dropdown } from "react-bootstrap";
import { Row as RowAnt, Col as ColAnt, Button as AntButton, Switch, Tooltip, Select as AntSelect  } from "antd";
import { Formik, Form, Field } from "formik";
import { useHistory } from "react-router";
import * as Yup from "yup";
import { isEmpty } from "lodash";
import { MailOutlined, PrinterOutlined, LinkOutlined } from "@ant-design/icons";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../../../../_metronic/_partials/controls";
import { ModalProgressBar, Input } from "../../../../../../../_metronic/_partials/controls";
import Invoice from "../../../../../Common/partials/invoice/Invoice";
import * as actions from "../../../../_redux/orders/ordersActions";
import { Notification } from "../../../../../Common/partials/Notification";
import {
  getCeleryTask,
  Payment_sub_type,
  Payment_type,
  SALE_INVOICE_TYPE,
  CELERY_PROGRESS_STATUS_OBJECT,
  DEFAULT_INVOICE_HEADER_TEMPLATE_ID,
  normalizeInvoiceHeaderTemplateId as normalizeTemplateId,
} from "../../../../../Common/constants";
import {
  DownloadPackingList,
  DownloadPickingList,
  getPresignedUrl,
  getSaleOrderByNo,
  sendEmail as sendEmailApi,
  uploadFileToCloud,
  useTaskStatus,
  generateEdiReport,
  generateExportExcelReport,
  saveInvoiceSetting,
  generateExportPDFinvoice
} from "../../../../_redux/orders/ordersCrud";
import * as settingActions from "../../../../../Estore/_redux/Estore/basicSettingsAction";
import { getSettingKey, getTimeByTimeZone, handleApiErrorResponse, InvoiceWrapper } from "../../../../../Common/utils";
import "./style.css";
import "react-phone-input-2/lib/style.css";
import AddPaymentModal from "./../../../../../Common/partials/payment/AddPaymentModal";
import WhatsAppMessageTrigger from "./whatsAppMessageTrigger";
import { DownloadOutlined } from "@ant-design/icons";
import PickingListModal from "./PickingListModal";
import { RightOutlined } from "@ant-design/icons";
import PackingListPrintViewModal from "./print-view-modal/PackingListPrintViewModal";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

export function CompleteCard({ history }) {
  // Get the current URL
  const [iconColor, setIconColor] = useState("black"); // Default color
  // Create a URL object
  // Note: I am doing this to get invoice value from url in case we want to make public url for invoice
  var urlString = window.location.href;
  var regex = /[?&]invoice=([^&#]*)/;
  var match = regex.exec(urlString);
  var public_key = match ? match[1] : null;

  // Getting Public Key from URL
  const url = new URL(window.location.href);
  const pk = url.searchParams.get("pk");

  const { settingState } = useSelector((state) => ({ settingState: state.basicSettings }), shallowEqual);

  const { entity } = settingState;
  console.log("🚀 ~ entity i am sssssssssssssssssssssssssssssssssssss:", entity);

  // let NMI_object = entity?.POS?.payments ? entity?.POS?.payments[Payment_type?.CREDIT_DEBIT_GATEWAY][Payment_sub_type?.NMI] : false
  const dist_name = getSettingKey(entity, "Basic", "dist_name");
  const admin_panel_settings = getSettingKey(entity, "IMMUTABLE_BASIC");

  const { currentBasicState } = useSelector(
    (state) => ({
      currentBasicState: state.basicSettings,
    }),
    shallowEqual
  );
  const timezone = getSettingKey(currentBasicState.entity, "Basic", "timezone");

  const immutableBasicSettings = getSettingKey(currentBasicState?.entity, "IMMUTABLE_BASIC");

  const adminPanelSettings = immutableBasicSettings["admin-panel"];
  const myPublicKey = localStorage.getItem("tenant_public_key") || '';
  const isCrossTenant = pk !== myPublicKey;
  const { currentState, authState } = useSelector((state) => ({ currentState: state.orders, authState: state.auth }), shallowEqual);
  const isMobileDevice =
    navigator.userAgentData?.mobile === true ||
    /Android|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    (navigator.userAgent.includes("Macintosh") && navigator.maxTouchPoints > 1);
  const hasInvoiceManagement = !isCrossTenant && (authState?.user || !isEmpty(authState?.user));
  const { currentOrder } = currentState;
  const [order, setOrder] = useState(currentOrder);
  const currentDisplayState = getSettingKey(currentBasicState.entity, "Invoice");

  const { product_details } = currentDisplayState;

  const invoiceHeaderTemplates = useMemo(() => {
    const templates = getSettingKey(entity, "Basic", "invoice_header_templates") || [];
    const defaultTemplate = {
      id: DEFAULT_INVOICE_HEADER_TEMPLATE_ID,
      name: "Default",
      tenant_invoice_logo: getSettingKey(entity, "Basic", "tenant_invoice_logo"),
      tenant_invoice_details: getSettingKey(entity, "Basic", "tenant_invoice_details"),
    };

    const normalizedTemplates = Array.isArray(templates) ? templates.map((template) => ({ ...template, id: normalizeTemplateId(template?.id) })) : [];

    return normalizedTemplates.some((template) => template?.id === DEFAULT_INVOICE_HEADER_TEMPLATE_ID)
      ? normalizedTemplates
      : [defaultTemplate, ...normalizedTemplates];
  }, [entity]);
  const getDefaultSelectedInvoiceHeaderTemplateId = () =>
    normalizeTemplateId(getSettingKey(entity, "Basic", "selected_invoice_header_template_id"));
  const hasInvoiceHeaderTemplateOverride = () =>
    Object.prototype.hasOwnProperty.call(order?.invoice_setting || {}, "invoice_header_template_id");
  const getSelectedInvoiceHeaderTemplateId = () =>
    hasInvoiceHeaderTemplateOverride()
      ? normalizeTemplateId(order?.invoice_setting?.invoice_header_template_id)
      : getDefaultSelectedInvoiceHeaderTemplateId();
  const selectedInvoiceHeaderTemplateIdForInvoice = getSelectedInvoiceHeaderTemplateId();
  const selectedInvoiceHeaderTemplate =
    invoiceHeaderTemplates.find((template) => normalizeTemplateId(template.id) === selectedInvoiceHeaderTemplateIdForInvoice) || invoiceHeaderTemplates[0];

  useEffect(() => {
    document.querySelector("body").style.overflowX = "hidden";
    const removeFlex = document.getElementById("kt_content");
    removeFlex?.classList?.remove("d-flex");
    removeFlex?.classList?.add("bg-white");
    const child = removeFlex?.children[1];
    child?.classList?.remove("d-flex");
    let removeContainer = document.getElementsByClassName("container")[0];
    !!removeContainer && removeContainer?.classList.remove("container");
    document.getElementById("kt_body")?.classList?.add("aside-hidden");
    document.getElementById("kt_body").style.overflowX = "hidden";
    document.getElementById("kt_header")?.classList?.add("d-none");
    document.getElementById("kt_subheader")?.classList?.add("d-none");
    document.getElementById("kt_footer")?.classList?.add("d-none");
    document.getElementById("kt_footer")?.classList.remove("d-flex");
    if (document.getElementById("kt_wrapper")?.style) {
      document.getElementById("kt_wrapper").style.paddingTop = "34px";
      document.getElementById("kt_wrapper").style.overflowX = "hidden";
    }
    document.getElementById("kt_wrapper")?.classList?.remove("wrapper");
    document.getElementById("kt_brand")?.classList.add("d-none");
  }, []);

  const history_ = useHistory();

  const [loading, setLoading] = useState(false);
  const [showImage, setShowImage] = useState(false);
  const [showSKU, setShowSKU] = useState(false);
  const [showTaxes, setShowTaxes] = useState(false);
  const [showMsrp, setShowMsrp] = useState(false);
  const [showBarcode, setShowBarcode] = useState(false);
  const [showCustomerBalance, setShowCustomerBalance] = useState(false);
  const [showPrice, setShowPrice] = useState(false);
  const [showExtCost, setShowExtCost] = useState(false);
  const [showAlternateName, setShowAlternateName] = useState(false);
  const [hideHeader, setHideHeader] = useState(false);
  const [showAddPaymentModal, setShowAddPaymentModal] = useState(false);

  const toggleHideHeader = () => {
    setHideHeader(!hideHeader);
  };
  const handleClose = () => setShowAddPaymentModal(false);
  const handleShow = () => setShowAddPaymentModal(true);
  const toggleImage = () => {
    setShowImage(!showImage);
  };
  const toggleSKU = () => {
    setShowSKU(!showSKU);
  };
  const toggleTaxes = () => {
    setShowTaxes(!showTaxes);
  };
  const toggleMsrp = () => {
    setShowMsrp(!showMsrp);
  };
  const toggleBarcode = () => {
    setShowBarcode(!showBarcode);
  };
  const toggleCustomerBalance = () => {
    setShowCustomerBalance(!showCustomerBalance);
  };
  const togglePrice = () => {
    setShowPrice(!showPrice);
  };
  const toggleExtCost = () => {
    setShowExtCost(!showExtCost);
  };
  const toggleAlternateName = (value) => {
    getAlternateName(value)
    setShowAlternateName(!showAlternateName);
  }; 

const getAlternateName = async (value) => {
  try {
    const response = await saveInvoiceSetting({
      orderId:order.id,
      payload: {
        "invoice_setting": {
          "invoice_with_alt": value,
        },
      },
    });
    const { message } = response.data;
    setOrder((prev) => ({
      ...prev,
      invoice_setting: { ...(prev?.invoice_setting || {}), invoice_with_alt: value },
    }));
    notification.success({ message: message });
  } catch (err) {
    handleApiErrorResponse(err);
  }
};

const handleInvoiceHeaderTemplateChange = async (templateId) => {
    const nextTemplateId = normalizeTemplateId(templateId);
    try {
      const response = await saveInvoiceSetting({
        orderId: order.id,
        payload: {
          invoice_setting: {
            invoice_header_template_id: nextTemplateId,
          },
        },
      });
      const { message } = response.data;
      setOrder((prev) => ({
        ...prev,
        invoice_setting: {
          ...(prev?.invoice_setting || {}),
          invoice_header_template_id: nextTemplateId,
        },
      }));
      notification.success({ message });
    } catch (err) {
      handleApiErrorResponse(err);
    }
  };

  const bodyRef = useRef();
  const dispatch = useDispatch();

  const { actionsLoading } = useSelector(
    (state) => ({
      actionsLoading: state.orders.actionsLoading,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (history_?.location?.pathname?.split("/sale/invoice/")[1]) {
      const queryParams = window.location.href.split("sale/invoice")[1];
      const publicKey = queryParams.split("?pk=")[1] || queryParams.split("?public_key=")[1];
      if (!admin_panel_settings?.public_key) {
        dispatch(
          settingActions.getSettings(
            { types: ["admin-panel"], sub_types: ["basic", "pos", "pos_invoice", "immutable_basic"], public_key: public_key || publicKey },
            history
          )
        );
      }

      if (admin_panel_settings?.public_key || public_key) {
        getOrderByNo(admin_panel_settings?.public_key || public_key);
      }
    }
    return () => {
      dispatch(actions.changeCompleteStatus(false));
    };
  }, [admin_panel_settings?.public_key, public_key]);

  const getOrderByNo = useCallback(
    async (_publicKey) => {
      const publicKey = admin_panel_settings?.public_key || public_key || _publicKey;
      if (publicKey) {
        try {
          setLoading(true);
          const response = await getSaleOrderByNo(history_?.location?.pathname?.split("/sale/invoice/")[1], publicKey);
          const { entity } = response.data;
          setOrder(entity);
          setShowAlternateName(entity.invoice_setting?.invoice_with_alt)
          setLoading(false);
        } catch (err) {
          try {
            setLoading(false);
            err.response.data.errors.map((error) => notification.error({ message: error }));
          } catch (err) {
            notification.error({ message: "Please contact to the support team" });
          }
        }
      }
    },
    [admin_panel_settings?.immutable_basic]
  );

  const sendEmail = (email) => {
    setLoading(true);
    try {
      const emailTemplate = {
        subject: "Sale Order Invoice",
        email_to: email,
        full_name: `${order?.customer?.first_name || ""} ${order?.customer?.last_name || ""}`,
        invoice_s3_key: "dummy",
        sale_order_id: order.id,
      };
      sendEmailApi(emailTemplate)
        .then((response) => {
          notification.success({ message: response?.data?.message });
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          handleApiErrorResponse(err);
          setLoading(false);
        });
    } catch (err) {
      setLoading(false);
      console.error("🚀 ~ file: index.js ~ line 83 ~ uploadFileToCloud ~ err", err);
    }
  };
  const convertedTimezone = getTimeByTimeZone(timezone, order.created_at, "MM/DD/YYYY");
  const printWrapperRef = useRef(null);

  const showPrintWrapper = () => {
    if (!printWrapperRef.current) return;
    printWrapperRef.current.style.display = "block";
    printWrapperRef.current.style.position = "fixed";
    printWrapperRef.current.style.left = "-10000px";
    printWrapperRef.current.style.top = "0";
    printWrapperRef.current.style.width = "1024px";
    printWrapperRef.current.style.maxWidth = "1024px";
    printWrapperRef.current.style.background = "#fff";
  };

  const hidePrintWrapper = () => {
    if (!printWrapperRef.current) return;
    printWrapperRef.current.style.display = "none";
    printWrapperRef.current.style.position = "";
    printWrapperRef.current.style.left = "";
    printWrapperRef.current.style.top = "";
    printWrapperRef.current.style.width = "";
    printWrapperRef.current.style.maxWidth = "";
    printWrapperRef.current.style.background = "";
  };

  const getPageMargins = () => {
    const marginTop = "10mm";
    const marginRight = "5mm";
    const marginBottom = "12mm";
    const marginLeft = "5mm";
    return `@page { margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important; width: 100% !important;  }`;
  };

  const handlePrint = useReactToPrint({
    content: () => {
      return bodyRef.current;
    },
    documentTitle: `${order.no} - ${order.customer?.business_name} - ${convertedTimezone}`,

    documentTitle: `${order?.no}`,

    onBeforeGetContent: () => {
      showPrintWrapper();
      // setReadytoPrint(true)

      // Remove Add Payment Button before printing
      const addPaymentButton = bodyRef.current.querySelector("#add-payment-button");
      if (addPaymentButton) {
        addPaymentButton?.remove();
      }

      // Add custom print styles
      const printStyles = document.createElement("style");
      printStyles.id = "custom-print-styles";
      printStyles.innerHTML = `
        .table-active {
          background-color: #e9ecef !important;
        }
        .table-active th {
          background-color: #e9ecef !important;
        }

        @media print {
          .pdf-body {
            margin-right: 0px !important;
            margin-left: 0px !important;
            padding-left: 0px !important;
            padding-right: 0px !important;
            padding-bottom: 5mm !important;
          }
          .container {
            max-width: 100% !important;
            padding-left: 0px !important;
            padding-right: 0px !important;
            margin-left: 0px !important;
            margin-right: 0px !important;
          }
          .invoice-body {
            padding-left: 0px !important;
            padding-right: 0px !important;
          }
          .table-active {
            background-color: #e9ecef !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          .table-active th {
            background-color: #e9ecef !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
        }
      `;
      document.head.appendChild(printStyles);

      // Temporary font size change for printing
      const elementsToModify = bodyRef.current.querySelectorAll("*"); // You can narrow down the selection as needed
      elementsToModify.forEach((element) => {
        element.style.fontSize = product_details?.Small ? "8pt" : product_details?.Medium ? "10pt" : product_details?.Large ? "12pt" : "12pt"; // Set the temporary font size to 24px
      });
    },
    onAfterPrint: () => {
      setTimeout(() => {
        document.getElementById("toggles").style.display = "";
        document.getElementById("socket-connector").style.display = "";
        document.getElementsByClassName("card-header")[0].style.display = "";
      }, 500);
      // document.getElementById("toggles").style.display = "";
      // setReadytoPrint(false)
      // Reset the font size after printing
      const elementsToModify = bodyRef.current.querySelectorAll("*"); // You can narrow down the selection as needed
      elementsToModify.forEach((element) => {
        element.style.fontSize = ""; // Reset to the original font size (empty string)
      });

      // Remove custom print styles
      const printStyles = document.getElementById("custom-print-styles");
      if (printStyles) {
        printStyles.remove();
      }
      hidePrintWrapper();
    },
  });

  let Invoicestatus = order?.invoice?.status;
  let isInvoiceUnpaid = Invoicestatus === 2;
  let isInvoiceDue = Invoicestatus === 1;
  let isInvoicePartiallyPaid = Invoicestatus === 5;

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [showEDIModal, setShowEDIModal] = useState(false);
  const formats = [
    {
      key: "custom",
      title: "Custom EDI format",
      image: "/media/logos/edi.png",
    },
    {
      key: "modisoft",
      title: "Modisoft EDI format",
      image: "/media/logos/modisoft.png",
    },
  ];

  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  const [taskStatus, setTaskStatus] = useState(null);

  const [showPackingListModal, setShowPackingListModal] = useState(false);
  const {
    exportStatus: packingListStatus,
    handleBackgroundTask,
    downloadUrl: packingListUrl,
  } = useTaskStatus(
    "packListId",
    (statusData) => {
      setTaskStatus(statusData);
    },
    true,
    pk
  );

  useEffect(() => {
    if (packingListStatus === CELERY_PROGRESS_STATUS_OBJECT.COMPLETED.slug) {
      setShowPackingListModal(true);
    }
  }, [packingListStatus]);

  const { exportStatus: ediStatus, handleBackgroundTask: handleBackgroundEdiTask } = useTaskStatus(
    "edi",
    (statusData) => {
      setTaskStatus(statusData);
    },
    false,
    pk
  );

  const {
    exportStatus: excelExportStatus,
    handleBackgroundTask: handleBackgroundExcelExportTask,
    downloadUrl: pickingListUrl,
  } = useTaskStatus(
    "excel-export-edi",
    (statusData) => {
      setTaskStatus(statusData);
    },
    false,
    pk
  );
  const {
    exportStatus: pdfExportStatus,
    handleBackgroundTask: handleBackgroundPDFExportTask,
  } = useTaskStatus(
    "pdf-export-edi",
    (statusData) => {
      setTaskStatus(statusData);
    },
    false,
    pk
  );

  const generatePackingLit = async () => {
    const id = order?.id;
    try {
      const response = await DownloadPackingList(id, pk);
      localStorage.setItem("packListId", response.data.id);
      handleBackgroundTask();
    } catch (err) {
      err.response?.data?.errors?.forEach((error) => notification.error({ message: error }));
    }
  };
  const generateEDI = async (format) => {
    const id = order?.id;
    try {
      const response = await generateEdiReport(id, pk, format);
      localStorage.setItem("edi", response.data.id);
      setShowEDIModal(false);
      handleBackgroundEdiTask();
    } catch (err) {
      err.response?.data?.errors?.forEach((error) => notification.error({ message: error }));
    }
  };
  const exportExcel = async () => {
    const id = order?.id;
    try {
      const response = await generateExportExcelReport(id, pk);
      localStorage.setItem("excel-export-edi", response.data.id);
      handleBackgroundExcelExportTask();
    } catch (err) {
      err.response?.data?.errors?.forEach((error) => notification.error({ message: error }));
    }
  };
  const exportPDF = async () => {
    const id = order?.id;
    try {
      const response = await generateExportPDFinvoice(id, pk);
      localStorage.setItem("pdf-export-edi", response.data.id);
      handleBackgroundPDFExportTask();
    } catch (err) {
      err.response?.data?.errors?.forEach((error) => notification.error({ message: error }));
    }
  };

  const invoiceUrl = `${window?.location?.origin}/sale/invoice/${order?.peculiar_no}?pk=${immutableBasicSettings?.public_key || adminPanelSettings?.immutable_basic?.public_key}`;
  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(invoiceUrl)
      .then(() => {
        setIconColor("blue"); // Change color to blue after copying
        setTimeout(() => setIconColor("black"), 2000); // Reset color after 2 seconds
        notification.success({
          message: "Link Copied!",
          description: "Invoice link has been copied to your clipboard.",
        });
      })
      .catch((error) => {
        console.error("Error copying the link:", error);
        notification.error({
          message: "Failed to Copy",
          description: "Could not copy the link. Please try again.",
        });
      });
  };

  const emailValidationSchema = Yup.object().shape({
    email: Yup.string()
      .test("valid-emails", "Invalid email format", (value) => {
        if (!value || value.includes(",,")) return false;

        const emails = value.split(",").map((email) => email.trim());
        const emailRegex = /^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
        return emails.every((email) => emailRegex.test(email) && !email.includes("..") && !email.includes("@-"));
      })
      .required("Email is required"),
  });

  const location = useLocation();
  const urlParams = new URLSearchParams(window.location.search);
  const from = urlParams.get("from");

  const handlePrintWithIOS = () => {
    try {
      document.getElementById("toggles").style.display = "none";
      document.getElementById("socket-connector").style.display = "none";
      document.getElementsByClassName("card-header")[0].style.display = "none";
      showPrintWrapper();
    } catch (error) {
      console.error("Error adding page margins:", error);
    } finally {
      setTimeout(() => {
        handlePrint();
      }, 1000);
    }
  };

  return (
    <Spin spinning={loading}>
      <Row style={{ margin: "0px" }}>
        <Col md={12} sm={12} style={{ paddingRight: "0.5px" }}>
          <Card className="m-0">
            {actionsLoading && <ModalProgressBar />}
            {(hasInvoiceManagement || isMobileDevice) && (
              <CardHeader className={!hasInvoiceManagement ? "invoice-public-header" : undefined}>
                <div className="w-100" id={"toggles"}>
                  <CardHeaderToolbar>
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        email: [
                          currentOrder?.customer?.email || order?.customer?.email,
                          currentOrder?.customer?.billing_email || order?.customer?.billing_email,
                        ]
                          .filter(Boolean)
                          .join(", "),
                      }}
                      validationSchema={emailValidationSchema}
                      onSubmit={({ email }) => {
                        const emailArray = email.split(",").map((e) => e.trim());
                        sendEmail(emailArray);
                      }}
                    >
                      {({ handleSubmit }) => (
                        <>
                          {hasInvoiceManagement ? (
                            <div className="d-flex justify-content-between w-100 invoice-header-content">
                              <h3 style={{ alignContent: "center" }}>Sale&nbsp;Invoice</h3>
                              <div className="hide-img-sku-barcode">
                                <RowAnt gutter={[8, 8]}>
                                  <ColAnt lg={2}></ColAnt>
                                  <ColAnt lg={10}>
                                    <WhatsAppMessageTrigger currentOrder={currentOrder} order={order} />
                                    <RowAnt>
                                      <ColAnt lg={17} sm={16} md={16} className="mt-5">
                                        <div className="mr-2">
                                          <Field
                                            name="email"
                                            component={Input}
                                            autoFocus={false}
                                            placeholder="Email*"
                                            customFeedbackLabel=" "
                                            showEmailInstruction={true}
                                            style={{ border: "1px solid #333" }}
                                          />
                                        </div>
                                      </ColAnt>
                                      <ColAnt className="mt-5" lg={6} sm={6} md={6}>
                                        <AntButton
                                          onClick={handleSubmit}
                                            className="sale-invoice-send-via-mail-btn"
                                        >

                                          <span className="d-flex align-items-center justify-content-center" style={{ gap: "4px" }}>
                                            Send via
                                            <span>
                                              <MailOutlined style={{ color: "white", fontSize: "14px", lineHeight: "30px" }} />
                                            </span>
                                          </span>
                                        </AntButton>
                                      </ColAnt>
                                    </RowAnt>
                                  </ColAnt>
                                  <ColAnt lg={12}>
                                    <div className="heading-box mt-2 hide-at-tab">
                                      <table width="100%">
                                        <tr>
                                          <td>
                                            Hide Image <Switch size="small" checked={showImage} onChange={toggleImage} style={{ marginLeft: "37px" }} />
                                          </td>
                                          <td className="hide-at-tab2">
                                            {" "}
                                            Hide SKU/UPC <Switch size="small" checked={showSKU} onChange={toggleSKU} style={{ marginLeft: "85px" }} />
                                          </td>

                                          <td>
                                            {" "}
                                            Hide Taxes Notes <Switch size="small" checked={showTaxes} onChange={toggleTaxes} style={{ marginLeft: "24px" }} />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td colSpan={2}>
                                            <p></p>
                                            <p></p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            Hide Barcode
                                            <Switch size="small" checked={showBarcode} onChange={toggleBarcode} style={{ marginLeft: "28px" }} />
                                          </td>
                                          <td>
                                            Hide Customer Balance
                                            <Switch
                                              size="small"
                                              checked={showCustomerBalance}
                                              onChange={toggleCustomerBalance}
                                              style={{ marginLeft: "25px" }}
                                            />
                                          </td>
                                          <td>
                                            Hide MSRP
                                            <Switch size="small" checked={showMsrp} onChange={toggleMsrp} style={{ marginLeft: "66px" }} />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <div style={{ marginTop: "12px" }}>
                                              Hide Price
                                              <Switch size="small" checked={showPrice} onChange={togglePrice} style={{ marginLeft: "72px" }} />
                                            </div>
                                          </td>
                                          <td>
                                            <div style={{ marginTop: "12px" }}>
                                              Hide Total/Extended
                                              <Switch size="small" checked={showExtCost} onChange={toggleExtCost} style={{ marginLeft: "50px" }} />
                                            </div>
                                          </td>
                                          <td>
                                            <div style={{ marginTop: "12px" }}>
                                              Hide Invoice Headers
                                              <Switch size="small" checked={hideHeader} onChange={toggleHideHeader} style={{ marginLeft: "5px" }} />
                                            </div>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td>
                                            <div style={{ marginTop: "12px" }}>
                                              Invoice with ALT
                                              <Switch size="small" checked={showAlternateName} onChange={toggleAlternateName} style={{ marginLeft: "15px" }} />
                                            </div>
                                          </td>
                                        </tr>
                                      </table>
                                    </div>
                                  </ColAnt>
                                  <ColAnt lg={24}>
                                    <RowAnt gutter={[10, 10]}>
                                      <ColAnt lg={10}>
                                        <div className="d-flex align-items-center my-2 mr-2" style={{ justifySelf:"right" }}>
                                          <p style={{marginRight:"4px", marginTop:"5px"}}>Select Invoice Header</p>
                                          <AntSelect
                                            value={normalizeTemplateId(selectedInvoiceHeaderTemplate?.id)}
                                            style={{ width: 240 }}
                                            onChange={handleInvoiceHeaderTemplateChange}
                                          >
                                            {invoiceHeaderTemplates.map((template) => (
                                              <AntSelect.Option key={normalizeTemplateId(template.id)} value={normalizeTemplateId(template.id)}>
                                                {template.name}
                                              </AntSelect.Option>
                                            ))}
                                          </AntSelect>
                                        </div>
                                      </ColAnt>
                                      <ColAnt lg={1} style={{ fontSize: "25px", color: iconColor }}>
                                        <Tooltip placement="top" title={"Copy Invoice Link"}>
                                          <LinkOutlined height={35} width={35} onClick={copyToClipboard} />
                                        </Tooltip>
                                      </ColAnt>
                                      <ColAnt lg={1} style={{ fontSize: "25px", color: "black" }}>
                                        <Tooltip placement="top" title={"Print Invoice"}>
                                          {" "}
                                          <PrinterOutlined height={35} width={35} onClick={handlePrintWithIOS} />
                                        </Tooltip>
                                      </ColAnt>
                                      <ColAnt lg={3}>
                                        <Button
                                          className="my-2 btn-info button-text"
                                          style={{ width: "100%" }}
                                          onClick={() => {
                                            window.location.href = "/v2/sale/sale-q-order";
                                            dispatch(actions.changeCompleteStatus(false));
                                          }}
                                        >
                                          Add Order
                                        </Button>
                                      </ColAnt>
                                      <ColAnt lg={3}>
                                        <div className="float-right my-2" style={{ width: "100%" }}>
                                          <button
                                            type="button"
                                            style={{ width: "100%" }}
                                            onClick={() => history.push(`/sale/fulfillment`)}
                                            className="btn btn-light button-text"
                                          >
                                            Back to Fulfilments
                                          </button>
                                        </div>
                                      </ColAnt>
                                      <ColAnt lg={3}>
                                        <div className="float-right my-2" style={{ width: "100%" }}>
                                          <button
                                            type="button"
                                            onClick={() => {
                                              let url = localStorage.getItem("fromURL");
                                              if (url && url?.split("/").find((el) => el == "fulfillment")) {
                                                history?.push("/sale/fulfillment");
                                              } else if (url && url?.split("/").find((el) => el == "history")) {
                                                history?.push("/sale/history");
                                              } else {
                                                history?.push("/sale/history");
                                              }
                                              localStorage.setItem("fromURL", "");
                                              dispatch(actions.changeCompleteStatus(false));
                                            }}
                                            className="btn btn-light button-text new-back-button-design-invoice"
                                            style={{ width: "100%" }}
                                          >
                                            Back
                                          </button>
                                        </div>
                                      </ColAnt>
                                      {order?.sale_type == 1 && (
                                        <ColAnt lg={1}>
                                          <Dropdown className="ml-2 my-2">
                                            <Dropdown.Toggle variant="info" id="dropdown-basic" className="custom-dropdown-toggle">
                                              <DownloadOutlined style={{ fontSize: "15px" }} />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="export-menu" style={{ width: "300px" }}>
                                              <Dropdown.Item onClick={handleOpenModal} style={{ width: "300px" }}>
                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                                  <div>Picking List</div>
                                                  <div>
                                                    <RightOutlined style={{ fontSize: "12px" }} />
                                                  </div>
                                                </div>
                                              </Dropdown.Item>
                                              <Dropdown.Item onClick={generatePackingLit}>Packing List</Dropdown.Item>
                                              <Dropdown.Item onClick={exportExcel}>Excel File</Dropdown.Item>
                                              <Dropdown.Item onClick={exportPDF}>PDF File</Dropdown.Item>
                                              <Dropdown.Item
                                                onClick={() => {
                                                  setShowEDIModal(true);
                                                }}
                                              >
                                                EDI Format
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </ColAnt>
                                      )}
                                      {pdfExportStatus && (
                                        <div className="d-flex justify-content-end" style={{ width: "100%" }}>
                                          <span className="mr-2 mt-2">
                                            Status: <b>{getCeleryTask(pdfExportStatus)}</b>
                                          </span>
                                        </div>
                                      )}
                                      {ediStatus && (
                                        <div className="d-flex justify-content-end" style={{ width: "100%" }}>
                                          <span className="mr-2 mt-2">
                                            Status: <b>{getCeleryTask(ediStatus)}</b>
                                          </span>
                                        </div>
                                      )}
                                      {excelExportStatus && (
                                        <div className="d-flex justify-content-end" style={{ width: "100%" }}>
                                          <span className="mr-2 mt-2">
                                            Status: <b>{getCeleryTask(excelExportStatus)}</b>
                                          </span>
                                        </div>
                                      )}
                                      {packingListStatus && packingListStatus !== CELERY_PROGRESS_STATUS_OBJECT.COMPLETED.slug && (
                                        <div className="d-flex justify-content-end" style={{ width: "100%" }}>
                                          <span className="mr-2 mt-2">
                                            Status: <b>{getCeleryTask(packingListStatus)}</b>
                                          </span>
                                        </div>
                                      )}
                                    </RowAnt>
                                  </ColAnt>
                                </RowAnt>
                              </div>
                              {isMobileDevice && <div className="invoice-mobile-actions">
                                {(isInvoiceUnpaid || isInvoiceDue || isInvoicePartiallyPaid) && (
                                  <Button onClick={handleShow} className="invoice-mobile-action-button btn-info">
                                    Add Payment
                                  </Button>
                                )}
                                <Dropdown className="invoice-mobile-download-dropdown">
                                  <Dropdown.Toggle
                                    variant="info"
                                    id="invoice-mobile-download-dropdown"
                                    className="custom-dropdown-toggle invoice-mobile-icon-button"
                                    aria-label="Download invoice files"
                                    title="Download invoice files"
                                  >
                                    <DownloadOutlined aria-hidden="true" />
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu className="export-menu invoice-mobile-export-menu">
                                    <Dropdown.Item onClick={generatePackingLit}>Packing List</Dropdown.Item>
                                    <Dropdown.Item onClick={exportExcel}>Excel File</Dropdown.Item>
                                    <Dropdown.Item onClick={exportPDF}>PDF File</Dropdown.Item>
                                    <Dropdown.Item onClick={() => setShowEDIModal(true)}>EDI Format</Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                                <Button onClick={handlePrintWithIOS} className="invoice-mobile-action-button invoice-print-action-button btn-info">
                                  Print / Save Invoice
                                </Button>
                              </div>}
                            </div>
                          ) : (
                            <Row className="invoice-public-actions">
                              {(isInvoiceUnpaid || isInvoiceDue || isInvoicePartiallyPaid) && (
                                <Button onClick={handleShow} className="invoice-public-action-button btn-info">
                                  Add Payment
                                </Button>
                              )}
                              <Dropdown className="invoice-public-download-dropdown">
                                <Dropdown.Toggle variant="info" id="dropdown-basic" className="custom-dropdown-toggle invoice-public-icon-button">
                                  <DownloadOutlined style={{ fontSize: "15px" }} />
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="export-menu invoice-public-export-menu">
                                  {/* <Dropdown.Item onClick={handleOpenModal} style={{ width: "300px" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                  <div>Picking List</div>
                                  <div>
                                    <RightOutlined style={{ fontSize: "12px" }} />
                                  </div>
                                </div>
                              </Dropdown.Item> */}
                                  <Dropdown.Item onClick={generatePackingLit}>Packing List</Dropdown.Item>
                                  <Dropdown.Item onClick={exportExcel}>Excel File</Dropdown.Item>
                                  <Dropdown.Item onClick={exportPDF}>PDF File</Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => {
                                      setShowEDIModal(true);
                                    }}
                                  >
                                    EDI Format
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                              <Button
                                className="invoice-public-action-button invoice-print-action-button btn-info"
                                onClick={handlePrintWithIOS}
                              >
                                Print / Save Invoice
                              </Button>
                              {ediStatus && ediStatus !== CELERY_PROGRESS_STATUS_OBJECT.COMPLETED.slug && (
                                <div className="d-flex justify-content-end" style={{ width: "100%" }}>
                                  <span className="mr-2 mt-2">
                                    Status: <b>{getCeleryTask(ediStatus)}</b>
                                  </span>
                                </div>
                              )}
                              {excelExportStatus && excelExportStatus !== CELERY_PROGRESS_STATUS_OBJECT.COMPLETED.slug && (
                                <div className="d-flex justify-content-end" style={{ width: "100%" }}>
                                  <span className="mr-2 mt-2">
                                    Status: <b>{getCeleryTask(excelExportStatus)}</b>
                                  </span>
                                </div>
                              )}
                              {packingListStatus && packingListStatus !== CELERY_PROGRESS_STATUS_OBJECT.COMPLETED.slug && (
                                <div className="d-flex justify-content-end" style={{ width: "100%" }}>
                                  <span className="mr-2 mt-2">
                                    Status: <b>{getCeleryTask(packingListStatus)}</b>
                                  </span>
                                </div>
                              )}
                            </Row>
                          )}
                          {showEDIModal ? (
                            <Modal
                              title="Choose EDI Format"
                              visible={showEDIModal}
                              footer={null}
                              onCancel={() => {
                                setShowEDIModal(false);
                              }}
                              width={650}
                            >
                              <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                                {formats.map((f) => (
                                  <Card
                                    key={f.key}
                                    hoverable
                                    bordered
                                    onClick={() => generateEDI(f.key == "custom" ? 1 : 2)}
                                    style={{
                                      borderColor: "#d9d9d9",
                                      height: "70px",
                                      cursor: "pointer",
                                      display: "flex",
                                    }}
                                  >
                                    <div style={{ display: "flex" }}>
                                      <img src={f.image} alt={f.title} style={{ width: 60, marginTop: "4px" }} />
                                      <div style={{ marginTop: "15px" }}>{f.title}</div>
                                    </div>
                                  </Card>
                                ))}
                              </div>
                            </Modal>
                          ) : null}
                        </>
                      )}
                    </Formik>
                  </CardHeaderToolbar>
                </div>
              </CardHeader>
            )}
            <CardBody className="invoice-card-body">
              {currentState.message.success && (
                <Notification message={currentState.message.success} actions={actions} variant="success" type="success" time={5} />
              )}
              <div id="invoice" className="pdf-body">
                <Container>
                  <InvoiceWrapper>
                    <Invoice
                      handlePrint={handlePrintWithIOS}
                      order={order}
                      invoiceType={SALE_INVOICE_TYPE.SALE.value}
                      showImage={showImage}
                      showSKU={showSKU}
                      showTaxes={showTaxes}
                      showMsrp={showMsrp}
                      showBarcode={showBarcode}
                      showAlternateName={showAlternateName}
                      hideInvoiceHeader={hideHeader}
                      showCustomerBalance={showCustomerBalance}
                      showPrice={showPrice}
                      showExtCost={showExtCost}
                      paymentbutton={false}
                      readytoPrint={false}
                      invoiceHeaderTemplate={selectedInvoiceHeaderTemplate}
                    />
                  </InvoiceWrapper>
                </Container>
              </div>
              {showAddPaymentModal ? <AddPaymentModal show={showAddPaymentModal} handleClose={handleClose} order={order} /> : null}
              <div id="invoice-which-print" ref={printWrapperRef} className="print-wrapper-root" style={{ display: "none" }}>
                <div ref={bodyRef} id="invoice" className="pdf-body print-container-only">
                  <InvoiceWrapper>
                    <Container>
                      <Invoice
                        handlePrint={handlePrintWithIOS}
                        order={order}
                        invoiceType={SALE_INVOICE_TYPE.SALE.value}
                        showImage={showImage}
                        showSKU={showSKU}
                        showTaxes={showTaxes}
                        showMsrp={showMsrp}
                        showBarcode={showBarcode}
                        showAlternateName={showAlternateName}
                        hideInvoiceHeader={hideHeader}
                        showCustomerBalance={showCustomerBalance}
                        showPrice={showPrice}
                        showExtCost={showExtCost}
                        paymentbutton={false}
                        readytoPrint={true}
                        invoiceHeaderTemplate={selectedInvoiceHeaderTemplate}
                      />
                    </Container>
                  </InvoiceWrapper>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
        {isModalVisible && <PickingListModal isVisible={isModalVisible} onClose={handleCloseModal} id={order?.id} publicKey={pk} />}
      </Row>

      {<PackingListPrintViewModal show={showPackingListModal} setShow={setShowPackingListModal} pdfLink={packingListUrl} />}
    </Spin>
  );
}
